/**
 * Identifier for 3p script bootstrap
 */
export const TYPE = 'mathml';
